import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNotifications } from "../../app/useNotifications";
import { usePayment } from "../../app/usePayment";
import { useHandleGetClientToken } from "../../app/useHandleGetClientToken";
import { ApplePayMask } from "./ApplePayMask";
export var ApplePayButton = function (_a) {
    var disabled = _a.disabled, _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, applePayDisplayName = _a.applePayDisplayName, lineItems = _a.lineItems, shipping = _a.shipping, shippingMethodId = _a.shippingMethodId;
    var _c = useState(false), applyPaySupport = _c[0], setApplyPaySupport = _c[1];
    var clientToken = usePayment().clientToken;
    var notify = useNotifications().notify;
    useEffect(function () {
        try {
            if (!("ApplePaySession" in window)) {
                throw new Error("ApplePaySession");
            }
            else {
                if (window.ApplePaySession.canMakePayments()) {
                    setApplyPaySupport(true);
                }
            }
        }
        catch (err) {
            notify("Error", "This device does not support Apple Pay".concat(", " + err, " "));
        }
    }, []);
    useHandleGetClientToken(disabled, undefined, shippingMethodId);
    return clientToken && applyPaySupport ? (_jsx(ApplePayMask, { fullWidth: fullWidth, applePayDisplayName: applePayDisplayName, lineItems: lineItems, shipping: shipping })) : (_jsx(_Fragment, {}));
};
